module.exports = __webpack_public_path__ + "static/media/grey_computer.277bbe06.svg";